<template>
    <div>
         <div class="card" >
            <table style="width:100%">
                <tr>
                    <SortItem title="Invoice ID" @set-sort="setSort" sortKey="invoice_number" :sort="sort"/>
                    <SortItem title="Invoice Number" @set-sort="setSort" sortKey="invoice_number" :sort="sort"/>
                    <SortItem title="Batch" @set-sort="setSort" sortKey="total_amount" :sort="sort"/>
                    <SortItem title="Internal validation error" @set-sort="setSort" sortKey="due_date" :sort="sort"/>
                    <SortItem title="Full MobilePay error response" @set-sort="setSort" sortKey="status" :sort="sort"/>
                    <SortItem title="MobilePay error message" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
                    <SortItem title="Created at" @set-sort="setSort" sortKey="created_at" :sort="sort"/>
                    <SortItem title="Updated at" @set-sort="setSort" sortKey="updated_at" :sort="sort"/>
                </tr>
                <tr v-for="report in importReports.data" :key="report.id" class="table-row" @="goToDetails(invoice)">
                    <td>{{report.invoice_id}}</td>
                    <td>{{report.invoice_number}}</td>
                    <td>{{report.batch}}</td>
                    <td>{{report.validation_error}}</td>
                    <td>{{report.full_mobilepay_error_response}}</td>
                    <td>{{report.mobilepay_error_message}}</td>
                    <td>{{report.created_at}}</td>
                    <td>{{report.updated_at}}</td>
                </tr>
            </table>

        </div>
        <div v-if="importReports.last_page && importReports.last_page > 1">
            <paginate
                :page-count="importReports.last_page || 1"
                :prev-text="'Prev'"
                :click-handler="onPageChange"
                :next-text="'Next'"
                :container-class="'paginate-container'">
            </paginate>
        </div>
    </div>
</template>

<script>
    import Paginate from 'vuejs-paginate'
    import SortItem from '../partials/SortItem.vue'
    import * as api from './api.js'
    export default {
        name:'ImportInvoices',
        components:{
            Paginate,
            SortItem
        },
        created() {
            this.fetchImportReports()
            document.title = 'Import Validation Report | PayGate Invoice'
        },
        methods:{
            fetchImportReports: async function(){
                this.importReports = await api.fetchImportReports({
                    id: this.$route.params.id,
                    page: this.page
                })
            },
            setSort(sort){
                if(this.sort.value == sort) {
                    if(this.sort.direction == 'asc') {
                        this.sort.direction = 'desc'
                    } else {
                        this.sort.direction = 'asc'
                    }
                } else {
                    this.sort.value = sort
                    this.sort.direction = 'asc'
                }
                this.fetchImports()
            },
            onPageChange: async function(page) {
                this.page = page
                this.fetchImportReports()
            },
        },
        data(){
            return {
                importReports:{},
                page: 1,
                sort: {
                    value:'created_at',
                    direction:'desc'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>
